import styled from "styled-components";

const ImageWrapper = styled.div`
  position: relative;
  width: ${({width}) => width + 'px'};
  height: ${({height}) => height + 'px'};
`

export { ImageWrapper }